
import { LatLng } from '@agm/core';
import { HttpClient } from '@angular/common/http';
import { AfterViewInit, Component, ElementRef, ViewEncapsulation } from '@angular/core';
import { async } from '@angular/core/testing';
import { Router } from '@angular/router';
import { fuseAnimations } from '@fuse/animations';
import { TranslateService } from '@ngx-translate/core';
import { AppInitializationService } from 'app/app-initialization.service';
import { Car } from 'app/models/car.model';
import { Container } from 'app/models/container.model';
import { DriverProcess, DriverProcessDetail, DriverProcessDetailEnum } from 'app/models/driverProcess.model';
import { Poligon, PoligonDetail } from 'app/models/poligon.model';
import { CarService } from 'app/services/car.service';
import { ContainerService } from 'app/services/container.service';
import { PoligonService } from 'app/services/poligon.service';
import { SimulationService } from 'app/services/simulation.service';
import { ToasterService } from 'app/services/user-interaction/services/toaster.service';
import { error } from 'console';
import * as L from 'leaflet';
import 'leaflet-draw';
import 'leaflet-routing-machine';
import { reject } from 'lodash';
import { NgxSpinnerService } from 'ngx-spinner';
import { isNullOrUndefined } from 'util';

//#region Icon

const iconUrl = 'assets/img/marker-icon.png';
const iconDefault = L.icon({
    iconUrl,
    iconSize: [30, 30],
    iconAnchor: [12, 41],
    popupAnchor: [1, -34],
    tooltipAnchor: [16, -28]
});

const ContainerIcon = L.Icon.extend({
    options: {
        iconSize: [25, 25],
        iconAnchor: [5, 20],
        popupAnchor: [1, -34],
        tooltipAnchor: [16, -28]
    }
})

const LeafIcon = L.Icon.extend({
    options: {
        iconSize: [40, 40], //30,30
        iconAnchor: [5, 5], //12,41
        popupAnchor: [15, 0],//1,34
        tooltipAnchor: [16, -28],
        shadowAnchor: [4, 62]
    }
});


L.Marker.prototype.options.icon = iconDefault;

//#endregion

@Component({
    selector: 'simulation-test',
    templateUrl: './simulation-test.component.html',
    styleUrls: ['./simulation-test.component.scss'],
    encapsulation: ViewEncapsulation.None,
    animations: fuseAnimations,
    providers: [PoligonService]
})

export class SimulationTestComponent implements AfterViewInit {

    public containerList: Array<Container> = []
    public garbageCenter: Container;
    public coordinates: L.LatLng[] = [];
    public cars: Array<Car>
    public selectCar = null;
    public speedTime = 1000;
    public selectCarControl = null;
    public totalDistance: number = 0;
    public totalDuration: number = 0;
    public totalContainer: number = 0;
    public totalEmptyContainer: number = 0;
    public distanceTraveled: number = 0;
    public totalFullContainer: number = 0;

    public simulation = true;
    public driverProcess: DriverProcess = {};
    private map;
    public start: any
    public finish: any
    public polygon: Poligon
    public destinations: any[]
    public myLocation: L.LatLng = L.latLng(0, 0);
    public car: Car
    private _containers: Array<PoligonDetail> = [];
    public map_car_icon = new LeafIcon({ iconUrl: 'assets/img/garbage-truck.png' });
    public car_marker = L.marker([0, 0], { icon: this.map_car_icon });

    public options = {
        enableHighAccuracy: true,
        timeout: 10000,
        maximumAge: 5000
    };

    constructor(
        private _toastService: ToasterService,
        private _simulationService: SimulationService,
        private appConfigService: AppInitializationService,
        private _spinner: NgxSpinnerService,
        private _http: HttpClient,
        private _translateService: TranslateService,
        private router: Router
    ) {
    }

    public get MapTileUrl(): string {
        return 'http://tile.openstreetmap.org/{z}/{x}/{y}.png';
    }


    private async initMap(): Promise<void> {
        this.map = L.map('map', {
            center: [39.09766, 34.56039],
            zoom: 15
        });

        await this.mySetLocation(this.map);

        const tiles = L.tileLayer(
            this.MapTileUrl, {
            maxZoom: 19,
            minZoom: 5,
            attribution: 'AKILLI-ATIK-SİSTEMİ'
        });

        tiles.addTo(this.map);
    }

    public async getByCar(): Promise<Car> {
        return new Promise(async (resolve, reject) => {
            try {
                var res = await this._simulationService.getByCar(this.selectCar.plate)
                resolve(res);
            } catch (error) {
                this._spinner.hide('routing');
                reject(error);
            }
        })
    }

    public async getByPoligon(): Promise<Poligon> {
        return new Promise(async (resolve, reject) => {
            try {
                var res = await this._simulationService.getByPoligon(this.car.polygonId);
                resolve(res);
            } catch (error) {
                this._spinner.hide('routing');
                reject(error);
            }
        })
    }

    async ngAfterViewInit(): Promise<void> {
        await this.getCars();
        localStorage.removeItem("driverProcess");
        if (this.selectCar != null) {
            this.car = await this.getByCar();
            this.polygon = await this.getByPoligon();

            if (isNullOrUndefined(this.car)) {
                this.car = new Car();
                this.car.plate = this._translateService.instant("UNDEFINED_USER");
            }
            this.selectCarControl = true;

            this._spinner.show('routing')

            setTimeout(async () => {
                await this.initMap();
                await this.getContainerList();
                await this.makeCapitalMarkers(this.map);
                this.mySetLocation(this.map)
                await this.SetDriverProcess()
                this._spinner.hide('routing');
            }, 2000);
        }
    }

    async makeCapitalMarkers(map: L.map): Promise<void> {
        var finishCoordinates: L.LatLng;
        this.coordinates.push(L.latLng(this.myLocation)); // 0 kendi konumu
        this._containers.forEach(x => {
            if (x.container.latitude && x.container.longitude) {
                if (x.container.containerType == true) {
                    const marker = L.marker([x.container.latitude, x.container.longitude], { icon: new ContainerIcon({ iconUrl: 'assets/img/end.png' }) });
                    marker.bindPopup(function () {
                        let html = `<div> ${this._translateService.instant("TITLE")} : ${x.container.streetDesc}</div>`;
                        return html;
                    });
                    marker.addTo(map);
                    finishCoordinates = new L.latLng(x.container.latitude, x.container.longitude)
                    this.garbageCenter = x.container;
                    return;
                }
                else {
                    this.totalContainer++;
                    var calculate = x.container.device.deviceLatestStatus
                        ? (((parseInt(x.container.altitude) - parseInt(x.container.deadZone)) - (parseInt(x.container.device.deviceLatestStatus.mesafe) - parseInt(x.container.deadZone)))
                            * 100) / (parseInt(x.container.altitude) - parseInt(x.container.deadZone)) : -1;
                    var map_icon;
                    // cengiz bey isteği çöp konteyneri 4 farklı renge bölme
                    if (calculate <= this.appConfigService.apiConfig["container-msf-yellow"]) {
                        map_icon = new ContainerIcon({ iconUrl: 'assets/img/trash-green.png' });
                    }
                    else if (calculate <= this.appConfigService.apiConfig["container-msf-orange"]) {
                        map_icon = new ContainerIcon({ iconUrl: 'assets/img/trash-yellow.png' });
                    }
                    else if (calculate <= this.appConfigService.apiConfig["container-msf-red"]) {
                        map_icon = new ContainerIcon({ iconUrl: 'assets/img/trash-orange.png' })
                    }
                    else {
                        map_icon = new ContainerIcon({ iconUrl: 'assets/img/trash-red.png' })
                    }

                    const marker = L.marker([x.container.latitude, x.container.longitude], { icon: map_icon });

                    var fullnessValue = calculate == -1 ? this._translateService.instant("UNDEFINED_VALUE") : calculate.toString().slice(0, 4);
                    marker.bindPopup(this.makeCapitalPopup(x.container.latitude + "/" + x.container.longitude, x.container.street, x.container.streetDesc, fullnessValue, x.container.name), { closeOnClick: false, autoClose: false })
                    marker.addTo(map);
                    if (calculate > this.polygon.treshold) {
                        this.totalFullContainer++;
                        this.coordinates.push(L.latLng(x.container.latitude, x.container.longitude))
                        this.containerList.push(x.container)
                    }
                    else {
                        this.totalEmptyContainer++;
                    }
                }
            }
        });
        this.destinations = (await this.TSPCalculator(this.coordinates)).map(s => s.LatLng);
        var startCoordinates = this.destinations[this.destinations.length - 1];
        await this.createStartRouting();
        await this.createFinishRouting(startCoordinates, finishCoordinates);
    }

    public tempAfterDistance = this.myLocation;
    public tempBeforeDistance = this.myLocation;
    async createStartRouting() {
        var index = 0;
        this.start = L.Routing.control({//gidiş rotası
            waypoints: this.destinations,    // coordinates in 0. konumu kendi konumumuz aynı zamanda waypointsin 0. sıda 
            lineOptions: {
                styles: [{ color: 'blue', opacity: 0.6, weight: 5 }]
            },
            //serviceUrl: 'http://router.project-osrm.org/route/v1',
            serviceUrl: this.appConfigService.apiConfig["routing-url"], //'http://127.0.0.1:5000/route/v1',
            addWaypoints: false,
            autoRoute: true,
            fitSelectedRoutes: false,
            routeWhileDragging: false,
            draggableWaypoints: false,
            showAlternatives: false,
            createMarker: function () { return null; },
            show: false
        }).addTo(this.map);

        this.start.on('routesfound', (event) => {
            if(!this.simulation){
                return;
            }
            const routes = event.routes;
            const coordinates = routes[0].coordinates;

            if (routes[0].instructions[1].type == 'WaypointReached') {
                this.setDriverProcessDetail(coordinates[0].lat, coordinates[0].lng, this.containerList[index])
                index++;
                this.destinations.splice(1, 1);
            }
            setTimeout(async () => {
                this.map.removeLayer(this.car_marker);

                if (coordinates.length <= 3) {
                    this.map.removeControl(this.start);
                    this.setDriverProcessDetail(coordinates[0].lat, coordinates[0].lng, this.containerList[index])
                    this.finishRoutingStart();
                    return;
                }
                else if (coordinates.length < 5) {
                    this.tempBeforeDistance = this.destinations[0];
                    this.destinations[0] = coordinates[1];
                    this.tempAfterDistance = this.destinations[0];
                    this.distanceTraveled += this.tempBeforeDistance.distanceTo(this.tempAfterDistance)
                    this.car_marker = L.marker([coordinates[1].lat, coordinates[1].lng], { icon: this.map_car_icon });
                }
                else {
                    this.tempBeforeDistance = this.destinations[0];
                    this.destinations[0] = coordinates[5];
                    this.tempAfterDistance = this.destinations[0];
                    this.distanceTraveled += this.tempBeforeDistance.distanceTo(this.tempAfterDistance)
                    this.car_marker = L.marker([coordinates[5].lat, coordinates[5].lng], { icon: this.map_car_icon });
                }
                this.car_marker.addTo(this.map);
                this.destinations = await (this.destinations).map(s => s);
                this.start.setWaypoints(this.destinations);
            }, this.speedTime);
        });
    }

    onSimulationClick(){
        this.simulation = !this.simulation;

        if (this.simulation) {
            const waypoints = this.start.getWaypoints();
            this.start.setWaypoints(waypoints);
            const waypoints2 = this.finish.getWaypoints();
            this.finish.setWaypoints(waypoints2);
        }
    }

    setDriverProcessDetail(carLat, carLng, container) {
        var driverProcessDeteail = new DriverProcessDetail();
        driverProcessDeteail.carLat = carLat.toString()
        driverProcessDeteail.carLng = carLng.toString()
        driverProcessDeteail.containerId = container.id;
        driverProcessDeteail.driverProcessId = this.driverProcess.id;
        driverProcessDeteail.status = DriverProcessDetailEnum.collected;
        driverProcessDeteail.visitDate = new Date();
        this._simulationService.addDriverProcessDetail(driverProcessDeteail);
    }

    finishDriverProcess(carLat, carLng) {
        this.driverProcess.endDate = new Date();
        this.driverProcess.endLat = carLat.toString();
        this.driverProcess.endLng = carLng.toString();
        this.driverProcess.distanceTraveled = this.distanceTraveled;
        this._simulationService.updateDriverProcess(this.driverProcess);

    }

    finishRoutingStart() {
        var wp = this.finish.getWaypoints();
        var start = wp[0];
        var finish = wp[1];
        this.map.removeControl(this.finish);
        this.createFinishRouting(start, finish)
        this.finish.on('routesfound', (event) => {
            if(!this.simulation){
                return;
            }
            const routes = event.routes;
            const coordinates = routes[0].coordinates;
            var waypoints = [];
            if (routes[0].instructions[1].type == 'WaypointReached') {
                this.finishDriverProcess(this.garbageCenter.latitude, this.garbageCenter.longitude);
            }
            setTimeout(async () => {
                this.map.removeLayer(this.car_marker);
                if (coordinates.length <= 3) {
                    this.finishDriverProcess(this.garbageCenter.latitude, this.garbageCenter.longitude);
                    localStorage.removeItem("driverProcess");
                    this.map.removeControl(this.finish);
                    return;
                }
                else if (coordinates.length <= 5) {
                    waypoints = this.finish.getWaypoints();
                    this.tempBeforeDistance = waypoints[0].latLng;
                    waypoints[0] = coordinates[1];
                    this.tempAfterDistance = waypoints[0];
                    this.distanceTraveled += this.tempBeforeDistance.distanceTo(this.tempAfterDistance)
                    this.car_marker = L.marker([coordinates[1].lat, coordinates[1].lng], { icon: this.map_car_icon });
                }
                else {
                    waypoints = this.finish.getWaypoints();
                    this.tempBeforeDistance = waypoints[0].latLng;
                    waypoints[0] = coordinates[5];
                    this.tempAfterDistance = waypoints[0];
                    this.distanceTraveled += this.tempBeforeDistance.distanceTo(this.tempAfterDistance)
                    this.car_marker = L.marker([coordinates[5].lat, coordinates[5].lng], { icon: this.map_car_icon });
                }
                this.car_marker.addTo(this.map);
                this.finish.setWaypoints(waypoints);
            }, this.speedTime);
        });
    }

    public async createFinishRouting(startCoordinates, finishCoordinates) {
        this.finish = L.Routing.control({//dönüş rotası çp merkezine
            waypoints: [startCoordinates, finishCoordinates],// en son konumdan çöp toplanma merkezine
            lineOptions: {
                styles: [{ color: 'red', opacity: 0.6, weight: 2 }]
            },
            serviceUrl: this.appConfigService.apiConfig["routing-url"],
            addWaypoints: false,
            autoRoute: true,
            fitSelectedRoutes: false,
            routeWhileDragging: false,
            draggableWaypoints: false,
            showAlternatives: false,
            createMarker: function () { return null; },
            show: false
        }).addTo(this.map);

        await this.someFunction();
    }

    async someFunction() {
        await new Promise<void>((resolve) => {
            this.finish.on('routesfound', async (e) => {
                var routes = e.routes;
                for (const route of routes) {
                    this.totalDuration += route.summary.totalTime;
                }
                resolve();
            });
        });
    }

    public async SetDriverProcess() {
        var dp = localStorage.getItem("driverProcess");
        if (dp) {
            try {
                this.driverProcess = await this._simulationService.getDriverProcessControl(dp);
            } catch (error) {
                console.warn(error);
                this._spinner.hide('routing');
            }
        }
        else {
            try {
                this.driverProcess.carId = this.car.id;
                this.driverProcess.sessionLogId = parseInt(localStorage.getItem('SessionLogId'))
                this.driverProcess.polygonId = this.car.poligon.id;
                this.driverProcess.startLat = this.myLocation.lat;
                this.driverProcess.startLng = this.myLocation.lng;
                this.driverProcess.estimatedDistance = this.totalDistance.toString();
                this.driverProcess.estimatedTime = this.totalDuration.toString();
                this.driverProcess.allContainerCount = this.totalContainer;
                this.driverProcess.fullContainerCount = this.totalFullContainer;
                this.driverProcess.emptyContainerCount = this.totalEmptyContainer;
                this.driverProcess.companyId = this.car.companyId;
                this.driverProcess.startDate = (new Date);
                this.driverProcess.simulation = true;
                this.driverProcess.endDate = null;
                this.driverProcess.shiftId = null;
                this.driverProcess.status = true;
                this.driverProcess = await this._simulationService.addDriverProcess(this.driverProcess);
                localStorage.setItem("driverProcess", this.driverProcess.id.toString())
            } catch (error) {
                console.warn(error);
                this._spinner.hide('routing');
            }
        }
    }

    public async getCars() {
        try {
            this.cars = await this._simulationService.getCars(parseInt(localStorage.getItem('CompanyID')))
        } catch (error) {
            console.warn(error);
            this._spinner.hide('routing')
        }
    }

    async mySetLocation(map: L.map) {

        if (navigator.geolocation) {

            navigator.geolocation.getCurrentPosition(position => {

                this.myLocation = new L.LatLng(position.coords.latitude, position.coords.longitude);
                this.map.setView(new L.LatLng(position.coords.latitude, position.coords.longitude), 15)
            },
                err => {
                    this._spinner.hide('routing')
                    this._toastService.toastWarning(this._translateService.instant("DEVICE_LOCATION_INFORMATION_COULD_NOT_BE_OBTAINED"));
                },
                this.options
            );
        }
    }

    private async getContainerList(): Promise<Array<Container>> {
        try {
            this._containers = await this._simulationService.getByPolygonsContainer(this.car.plate);
        } catch (error) {
            console.warn(error);
            this._spinner.hide('routing')
            return [];
        }
    }


    public async TSPCalculator(coords: L.LatLng[]): Promise<Array<OrderCoord>> {

        let orderCoords = new Array<OrderCoord>();
        let calculateOrderCoords = new Array<OrderCoord>();

        let response = await this.getMatris(coords);
        let tsp = await this.postTSP(response.distances);
        let matris = response.distances;

        for (let i = 0; i < matris.length; i++) {
            let orderCoordRR = new OrderCoord();
            orderCoordRR.LatLng = new L.LatLng(response.destinations[i].location[1], response.destinations[i].location[0])
            orderCoordRR.durations = matris[i];
            calculateOrderCoords.push(orderCoordRR);
        }

        for (let a = 0; a < tsp.length - 1; a++) {
            orderCoords.push(calculateOrderCoords[tsp[a]]);
            if (a == tsp.length - 2) {
                var tempLocation = calculateOrderCoords[tsp[a]].LatLng;
                this.totalDistance += tempLocation.distanceTo(new L.LatLng(this.garbageCenter.latitude, this.garbageCenter.longitude))

            }
            this.totalDuration += parseInt(response.durations[tsp[a]][tsp[a + 1]]);
            this.totalDistance += parseInt(response.distances[tsp[a]][tsp[a + 1]]);

        }

        this._containers.filter(x => x.discriminator != 'garbage-center').forEach(y => {
            this.totalDuration += y.container.collectionTime;
        });

        return orderCoords;
    }

    postTSP(durations: any): Promise<any> {
        return new Promise((resolve, reject) => {
            this._http.post(this.appConfigService.apiConfig["api-url"] + 'routeOptimization/getRouteOptimization', durations)
                .subscribe((response: any) => {
                    resolve(response);
                }, error => {
                    this._spinner.hide('routing')
                    reject(error)
                });
        });
    }

    getMatris(coords: L.LatLng[]): Promise<any> {
        var httpString: string = "";
        for (let x = 0; x < coords.length; x++) {
            httpString += coords[x].lng + "," + coords[x].lat;
            if (x != coords.length - 1) {
                httpString += ";"
            }
        }
        return new Promise((resolve, reject) => {
            this._http.get(this.appConfigService.apiConfig["table-url"] + httpString + "?annotations=distance,duration")
                .subscribe((response: any) => {
                    resolve(response);
                }, error => {
                    this._spinner.hide('routing')
                    reject(error)
                });
        });
    }

    public routingLoop(coords: L.LatLng[]): Array<OrderCoord> {

        let orderCoords = new Array<OrderCoord>();
        let calculateOrderCoords = new Array<OrderCoord>();
        let filterCoords = new Array<OrderCoord>();

        let orderCoord = new OrderCoord(); //ilk konum
        orderCoord.value = 0;
        orderCoord.LatLng = coords[0];
        orderCoords.push(orderCoord);

        let selectedCoord = coords[0];
        coords[0].op = true;

        for (var index_all = 0; index_all < coords.length; index_all++) {  //sadece döngü için 


            calculateOrderCoords = new Array<OrderCoord>();

            filterCoords = coords.filter(x => x !== selectedCoord && x.op !== true);
            for (var index_filter = 0; index_filter < filterCoords.length; index_filter++) {    //sırayla gez hesaplanan noktayı devre dışı bırak
                let coord = filterCoords[index_filter];
                let value = selectedCoord.distanceTo(coord);
                let orderCoord = new OrderCoord();
                orderCoord.value = value;
                orderCoord.LatLng = coord;
                calculateOrderCoords.push(orderCoord);
            }

            let shortestPath = calculateOrderCoords.sort((a, b) => (a.value < b.value ? -1 : 1));

            if (!isNullOrUndefined(shortestPath[0] && shortestPath[0].LatLng)) {

                orderCoords.push(shortestPath[0]); //bulduğun en kısa yolu rota listesine ekle 
                var index = coords.findIndex(function (el) {
                    return el.lat == shortestPath[0].LatLng.lat;
                });
                coords[index].op = true; //en yakını
                selectedCoord = shortestPath[0].LatLng;
            }

        }
        return orderCoords;

    }

    makeCapitalPopup(latLng: string, street: string, streetDesc, fullness: string, name?: string): string {
        let html = `<div> ${this._translateService.instant("OCCUPANCY")} : % ${fullness}</div>`;
        html += `<div> ${this._translateService.instant("NAME")}: ${name}</div>`;
        html += `<div> ${this._translateService.instant("TITLE")}: ${streetDesc}</div>`;
        html += `<div> ${this._translateService.instant("STREET")}: ${street}</div>`;
        return html;
    }
}


export class OrderCoord {
    public LatLng?: any
    public value?: number
    public durations?: Array<any>
    public op?: boolean = false
}






